import classNames from "classnames";
import React, { CSSProperties, ReactNode } from "react";
import { FormRow } from ".";

type FormProps = {
    as?: string;
    className?: string;
    labelWidth?: any;
    labelClassName?: string;
    controlClassName?: string;
    inline?: boolean;

    height?: any;
    width?: any;
    maxWidth?: any;
    maxHeight?: any;
    style?: CSSProperties | undefined;

    children?: ReactNode;
    onSubmit?: (e: any) => void;
    [x: string]: any;
};

export const Form = ({
    as,
    action,
    className,
    labelWidth,
    labelClassName,
    controlClassName,
    compact,
    inline,
    //initialValues,
    //validationSchema,
    onSubmit,
    //innerRef,
    //validate,
    //enableReinitialize,
    //setFildValue,

    height,
    width,
    maxWidth,
    maxHeight,
    style,

    children,
    ...props
}: FormProps) => {
    var cn = classNames("bd-form", className, {
        "form-vertical": !inline || !labelWidth,
        "bd-form-inline": inline,
        "bd-form-compact": compact,
    });

    const MapChildren = (children: React.ReactNode) =>
        React.Children.map(children, (child) => {
            if (!React.isValidElement(child)) return child;
            var x: any = child;
            if (x?.type === FormRow) {
                let newProps = {
                    labelWidth,
                    labelClassName,
                    controlClassName,
                    ...child.props,
                    children: MapChildren(child.props?.children),
                };
                return React.cloneElement(child, newProps);
            }

            return !child.props?.children
                ? child
                : React.cloneElement(child, { ...child.props, children: MapChildren(child.props.children) });
        });

    if (action) props.action = action;
    if (cn) props.className = cn;
    if (onSubmit) props.onSubmit = onSubmit;
    if (style || height || width || maxWidth || maxHeight) props.style = { ...style, width, maxWidth, height, maxHeight };
    children = MapChildren(children);

    return as ? React.createElement(as, props, children) : <form {...props}>{children}</form>;
};
